import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import * as Yup from 'yup';
import { Formik, Form as FormikForm } from 'formik';
import { Button, Form as BootstrapForm } from 'react-bootstrap5';
import HorizontalTextField from 'components/new_ui/Form/HorizontalTextField';
import HorizontalSelectField from 'components/new_ui/Form/HorizontalSelectField';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

import { useClaimContext } from 'contexts/ClaimContext';
import FormInfo from './FormInfo';

export default function Form({ claim, onCloseClick, onSubmit }) {
  const { dispatch, state, actions } = useClaimContext();

  const formSchema = Yup.object().shape({
    member: Yup.string().typeError('Member is required'),
    claimType: Yup.string().required('Claim Type is required'),
    reason: Yup.string().required('Details are required'),
  });

  useEffect(() => {
    actions.loadMembers(dispatch);
  }, []);

  return (
    <Formik
      validationSchema={formSchema}
      initialValues={{
        member: claim === null ? null : claim.attributes.member,
        claimType: claim === null ? 'Talent Insurance' : claim.attributes.claim_type,
        reason: claim === null ? '' : claim.attributes.body,
      }}
      onSubmit={onSubmit}
    >
      {({ isSubmitting }) => (
        <FormikForm className="needs-validation" noValidate="">
          {claim === null && (
          <HorizontalSelectField
            name="member"
            label="Member"
            placeholder={state.members === null ? 'Loading...' : 'Select Member'}
            options={state.members || []}
            required
          />
          )}
          {claim !== null && (
            <>
              <BootstrapForm.Label>
                Member
                <abbr className="ms-1" title="required">*</abbr>
              </BootstrapForm.Label>
              <BootstrapForm.Control
                type="text"
                disabled
                value={claim.attributes.member}
              />
            </>
          )}
          {claim !== null && (
            <>
              <div>
                <BootstrapForm.Label>
                  Program
                  <abbr className="ms-1" title="required">*</abbr>
                </BootstrapForm.Label>
                <BootstrapForm.Control
                  type="text"
                  disabled
                  value={claim.attributes.program.title}
                />
              </div>
              <div>
                <BootstrapForm.Label>
                  Completed
                  <abbr className="ms-1" title="required">*</abbr>
                </BootstrapForm.Label>
                <BootstrapForm.Control
                  type="text"
                  disabled
                  value={claim.attributes.program.last_session_completed_date}
                />
              </div>
            </>
          )}
          {claim === null && <FormInfo />}
          <HorizontalTextField name="claimType" disabled label="Claim Type" required />
          <HorizontalTextField as="textarea" name="reason" label="Details" required />

          <footer>
            <Button
              variant="outline-primary"
              disabled={isSubmitting}
              onClick={() => onCloseClick()}
            >
              Cancel
            </Button>

            <Button
              type="submit"
              disabled={isSubmitting}
            >
              {isSubmitting && (
              <LoadingPlaceholder placement="inline" text=" " />
              )}
              Save
            </Button>
          </footer>
        </FormikForm>
      )}
    </Formik>
  );
}

Form.propTypes = {
  claim: PropTypes.object,
  onCloseClick: PropTypes.func,
  onSubmit: PropTypes.func,
};

Form.defaultProps = {
  claim: null,
  onCloseClick: () => {},
  onSubmit: () => {},
};
